import {fetchQuery, GraphQLTaggedNode} from 'relay-runtime';
import environment from '../../../RelayEnvironment';
import {useState} from 'react';
import {noop} from 'lodash';

export const useForecastFetchQuery = <DataType, VariablesType extends Record<string, unknown>>(
	query: GraphQLTaggedNode,
	clearDataOnFetch = false,
	// Mission Control pages keep their own Relay store (RelayEnvironment.getInstanceMC); fetching
	// into it is what lets an imperative refetch update the page's fragments.
	isMc = false
): {
	data: DataType | null;
	/** `onSuccess` receives this fetch's own response. A caller that can have several fetches in
	 * flight (search as you type) reads it from there, because `data` holds whichever response
	 * landed last, which is not necessarily the one for the latest request. */
	fetch: (variables?: VariablesType, onSuccess?: (data: DataType) => void, onError?: () => void) => void;
	loading: boolean;
} => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState<DataType | null>(null);

	const fetch = (variables = {}, onSuccess = noop, onError = noop) => {
		setLoading(true);
		if (clearDataOnFetch) {
			setData(null);
		}
		fetchQuery(isMc ? environment.getInstanceMC() : environment.getInstance(), query, variables)
			.toPromise()
			.then(
				data => {
					setData(data as DataType);
					setLoading(false);
					onSuccess(data as DataType);
				},
				() => {
					setLoading(false);
					onError();
				}
			);
	};

	return {fetch, data, loading};
};
